"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasValue = void 0;
function hasValue(value) {
    return value !== null && value !== undefined;
}
exports.hasValue = hasValue;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy91dGlsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLFNBQWdCLFFBQVEsQ0FBSSxLQUEyQjtJQUNyRCxPQUFPLEtBQUssS0FBSyxJQUFJLElBQUksS0FBSyxLQUFLLFNBQVMsQ0FBQztBQUMvQyxDQUFDO0FBRkQsNEJBRUMifQ==